import { render } from "./ServicesDatatableActionsPrice.vue?vue&type=template&id=14d62547"
import script from "./ServicesDatatableActionsPrice.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableActionsPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__